import { render, staticRenderFns } from "./DialogCloseNavigation.vue?vue&type=template&id=5c045c02&scoped=true&"
import script from "./DialogCloseNavigation.vue?vue&type=script&lang=ts&"
export * from "./DialogCloseNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./DialogCloseNavigation.vue?vue&type=style&index=0&id=5c045c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c045c02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
